import { all } from "redux-saga/effects";

import {
    loginWatcher,
    loginSuccessWatcher,
    loginFailWatcher
} from "./login.saga";
import {
    signupActionWatcher,
    signupSuccessWatcher,
    signupFailWatcher
} from "./signup.saga";
import {
    recoverActionWatcher,
    recoverSuccessWatcher,
    recoverFailWatcher
} from "./recover.saga";
import {
    newPasswordActionWatcher,
    newPasswordSuccessWatcher,
    newPasswordFailWatcher
} from "./newPassword.saga";

import {
    getUsersWatcher,
    changeUserStatusWatcher,
    createUserWatcher,
    editUserWatcher,
    editUserPasswordWatcher
} from "./users.saga";

import { getUsersPrivilegesWatcher } from "./usersPrivileges.saga";

import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";

import {
    createRoleWatcher,
    getRolesWatcher,
    deleteRoleWatcher,
    editRoleWatcher,
    getResourceEntityWatcher
} from "./roles.saga";

export default function* rootSaga() {
    yield all([
        loginWatcher(),
        loginSuccessWatcher(),
        loginFailWatcher(),
        signupActionWatcher(),
        signupSuccessWatcher(),
        signupFailWatcher(),
        recoverActionWatcher(),
        recoverSuccessWatcher(),
        recoverFailWatcher(),
        newPasswordActionWatcher(),
        newPasswordSuccessWatcher(),
        newPasswordFailWatcher(),
        changeUserStatusWatcher(),
        getUsersWatcher(),
        getUsersPrivilegesWatcher(),
        createUserWatcher(),
        editUserWatcher(),
        createRoleWatcher(),
        getRolesWatcher(),
        deleteRoleWatcher(),
        editRoleWatcher(),
        getSubsidiariesWatcher(),
        editUserPasswordWatcher(),
        getResourceEntityWatcher()
    ]);
}
